import { connect } from 'react-redux';
import EditQuizQuestions from './EditQuizQuestions';
import { saveQuestion, destroyQuestion } from '../../../actions/questionActions';

export default connect(null, {
  saveQuestion,
  destroyQuestion,
})(EditQuizQuestions);
